import { getRootDomain, resolveFirebaseAuthDomain } from "environments/environment-helpers";
import { FIREBASE_WEB_API_KEY_PROD } from '@cf-shared/firebase-web-api-keys';

export const firebaseConfig_prod = {
  // Firebase platform key — auth-only. See design-docs/secrets-inventory.md
  // "Firebase Platform API Keys" before widening its API allow-list (a 2025
  // Console wizard silently added Vertex AI in Firebase and that led to the
  // 2026-06-03 → 06-05 dev incident).
  apiKey: FIREBASE_WEB_API_KEY_PROD,
  // Mobile web (iOS Safari + Android browsers) falls back to the firebaseapp.com default
  // (custom authDomain breaks there under browser storage partitioning) — see resolveFirebaseAuthDomain.
  authDomain: resolveFirebaseAuthDomain(getRootDomain(), 'cybernetic-fitness-app'),
  databaseURL: 'https://cybernetic-fitness-app.firebaseio.com',
  projectId: 'cybernetic-fitness-app',
  messagingSenderId: '896009282039',
  appId: "1:896009282039:web:824ee05cf10823e8908ef2",
  measurementId: "G-X5HE31YJSB"
};
